import {Box,Autocomplete,TextField} from '@mui/material';
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldAutocompleteCountry=({row,fieldName,application,recordRules,readOnly,setFieldValue,showPhoneCode=false})=>{
    const fieldProp=row?.[fieldName];
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const countries=application.globalData.countries;
    const value=fieldProp.value?fieldProp?.value:null;
    const value_LIC=value?application?.globalData?.list_of_values_reverse?.Country[value]:null;
    const value_phone_code=value_LIC?countries.find((country)=>country.country===value_LIC)?.phone_code:null;

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <Autocomplete
                style={{marginTop:"0px"}}
                readOnly={readOnlyEvaluated}
                fullWidth
                isOptionEqualToValue={(option,value)=>option?.country===value?.country}
                options={countries}
                getOptionLabel={(option)=>{
                    let return_option='';
                    if(typeof option==='object'){return_option=application.globalData.list_of_values.Country[option.country];}
                    else if(option){return_option=option;}
                    return return_option;
                }}
                renderOption={(props,option)=>{
                    const {key,...otherProps}=props;
                    return (
                    <Box key={key} component="li" sx={{'& > img':{mr:2,flexShrink:0}}} {...otherProps}>
                        <img
                            loading="lazy"
                            width="20"
                            src={require('../../assets/flags/'+option.country+'.png')}
                            alt=""/>
                        {application.globalData.list_of_values.Country[option.country]}
                        {showPhoneCode&&(<Box component="span" sx={{ml:0.5}}>({option.phone_code})</Box>)}
                    </Box>
                )}}
                id={fieldName}
                name={fieldName}
                type={fieldProp?.ui_type}
                size="small"
                value={value}
                onChange={(event,newValue)=>{setFieldValue(fieldName,newValue?application?.globalData?.list_of_values.Country[newValue.country]:null);}}
                renderInput={(params)=>(
                <TextField
                    {...params}
                    label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                    size="small"
                    variant="outlined"
                    sx={{"& .MuiOutlinedInput-root":{backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:undefined,},}}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment:
                            value?(
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:1,
                                        pl:1,
                                    }}>
                                    <img
                                        width="20"
                                        src={require("../../assets/flags/" +value_LIC+".png")}
                                        alt=""/>
                                </Box>
                            ):null,
                        endAdornment:
                            value&&showPhoneCode?(
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:1,
                                        pl:1,
                                    }}>
                                    ({value_phone_code})
                                </Box>
                            ):null,
                    }}/>
                )}
            />
        </Box>
    );
}

export default FieldAutocompleteCountry;
